<template>
  <div v-if="hasAcademicStatusData">
    <AthleteSectionSubheading>Academic Status</AthleteSectionSubheading>
    <div
      class="flex flex-col md:flex-row flex-wrap p-4 mb-8 overflow-hidden bg-white rounded shadow card gap-6 items-stretch"
    >
      <AthleteField
        v-if="parseInt(user.gpa.value) && !isUserWithoutAccess"
        ref="gpa"
        :label="`Gpa ${user.gpa.isWeighted ? '<span class=\'lowercase ds-text-2xs font-semibold text-gray-500\'>(weighted)</span>' : ''}`"
        class="academic-status-item"
      >
        <p class="m-0 font-medium text-gray-900 ds-text-4xl">{{ user.gpa.value }}/{{ user.gpa.scale }}</p>
      </AthleteField>
      <AthleteField
        v-if="user.classYear"
        ref="classYear"
        label="class year"
        class="academic-status-item"
      >
        <p class="m-0 font-medium text-gray-900 ds-text-4xl">
          {{ user.classYear }} {{ user.isTransfer ? 'Transfer' : '' }}
        </p>
      </AthleteField>
      <AthleteField
        v-if="user.classRank && !isUserWithoutAccess"
        ref="classRank"
        label="class rank"
        class="academic-status-item"
      >
        <p class="m-0 font-medium text-gray-900 ds-text-4xl">{{ user.classRank }}/{{ user.classSize }}</p>
      </AthleteField>
      <AthleteField
        v-if="user.ncaaEligibilityNumber && !isUserWithoutAccess"
        ref="ncaaEligibilityNumber"
        label="ncaa eligibility #"
        class="academic-status-item"
      >
        <p class="m-0 font-medium text-gray-900 truncate ds-text-4xl">{{ user.ncaaEligibilityNumber }}</p>
      </AthleteField>
      <AthleteField
        v-if="user.intendedMajor && !isUserWithoutAccess && !useCollegePreferences"
        ref="intendedMajor"
        label="intended major / area of study"
        class="academic-status-item"
      >
        <p class="m-0 ds-text-base font-medium text-gray-900">{{ user.intendedMajor }}</p>
      </AthleteField>
      <AthleteField
        v-if="user.preferredMajors && user.preferredMajors.length > 0 && !isUserWithoutAccess && useCollegePreferences"
        ref="preferredMajors"
        label="intended major"
        class="academic-status-item"
      >
        <PillGroup :items="user.preferredMajors" class="mb-3" />
      </AthleteField>
    </div>
  </div>
</template>

<script>
import AthleteField from "../../AthleteField.vue";
import { mapState, mapGetters } from "vuex";
import AthleteSectionSubheading from "../../AthleteSectionSubheading.vue";
import PillGroup from "../../PillGroup.vue";

export default {
  components: {
    AthleteField,
    AthleteSectionSubheading,
    PillGroup,
  },
  computed: {
    ...mapState({
      user: state => state.athleteProfile.user,
    }),
    ...mapGetters({
      isUserWithoutAccess: "athleteProfile/isUserWithoutAccess",
      useCollegePreferences: "athleteProfile/useCollegePreferences",
    }),
    hasAcademicStatusData() {
      return (
        parseInt(this.user.gpa.value) ||
        this.user.classYear ||
        this.user.classRank ||
        this.user.ncaaEligibilityNumber ||
        this.user.intendedMajor
      );
    },
  },
};
</script>

<style scoped>
  @media (max-width: 767px) {
    .academic-status-item {
      width: calc(100% - 1.5rem);
    }
  }

  @media (min-width: 768px) {
    .academic-status-item {
      flex: 1 0 calc(50% - 1.5rem);
      width: calc(50% - 1.5rem);
    }
  }

  @media (min-width: 1024px) {
    .academic-status-item {
      flex: 1 0 calc(33.333% - 1.5rem);
      width: calc(33.333% - 1.5rem);
    }
  }
</style>